import { render, staticRenderFns } from "./AddPatientToTest.vue?vue&type=template&id=70fc7252&scoped=true"
import script from "./AddPatientToTest.vue?vue&type=script&lang=js"
export * from "./AddPatientToTest.vue?vue&type=script&lang=js"
import style0 from "./AddPatientToTest.vue?vue&type=style&index=0&id=70fc7252&prod&scoped=true&lang=css"
import style1 from "./AddPatientToTest.vue?vue&type=style&index=1&id=70fc7252&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fc7252",
  null
  
)

export default component.exports